import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    fetchCompanyPending: false,
    storeCompanyPending: false,
    fetchLocationPending: false,
    company: {},
    checkCompanyProfilePending: false,
    missingInformation: [],
    profileCompleted: false,
    fetchContactPersonPending: false,
    storeContactPersonPending: false,
    contactPerson: {},
  },
  actions,
  mutations,
};
